import React from 'react';
import { useTranslation } from 'react-i18next';
import { deviceTimeZone } from '../lib/timezone.js';

// Manual scheduling inputs and previews currently use the browser's zone.
// Label that existing interpretation without changing stored UTC instants.
export function DeviceTimezoneLabel({ timezone = deviceTimeZone(), compact = false }) {
  const { t } = useTranslation();
  const label = t('settings.manualTimezone', { zone: timezone });
  return <span className="caption muted" title={label}>{compact ? timezone : label}</span>;
}
